module.exports = __webpack_public_path__ + "static/media/hilux-mk8-extra-cab.1d57c666.webp";